<script>
import debounce from 'lodash/debounce';

export default {
  props: {
    type: {
      type: String,
      default: 'amount',
    },
  },
  data: () => ({
    eventStart: null,
    eventEnd: null,
    firstValue: null,
    edited: false,
  }),
  computed: {
    name() {
      return `slider-${this.type}`;
    },
    target() {
      return this.$store.getters[`arithmetic/${this.type}`].current;
    },
    behaviour() {
      const { eventStart, eventEnd, firstValue, edited, name } = this;
      return {
        name,
        eventStart,
        eventEnd,
        eventDuration: eventEnd - eventStart,
        firstValue,
        edited,
      };
    },
  },
  watch: {
    target: debounce(function(val) {
      const time = Date.now();
      if (this.eventStart === null) {
        this.eventStart = time;
        this.firstValue = val;
      } else {
        this.edited = true;
      }

      this.eventEnd = time;
    }, 300),
  },
  render: () => '',
};
</script>
